import React from 'react';

import {Helmet} from 'views/module';

import ClientLeadListScene from 'views/scenes/client_lead/list/ClientLeadList';

const ClientLeadList = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Client Leads</title>
      </Helmet>
      <ClientLeadListScene
      />
    </>
  );
};

export default ClientLeadList;
